import { FlowTestingSlugResponse } from '@driftt/api-types'
import qs from 'qs'

import { FlowAPI } from 'api'

interface FetchTestDataParams {
  interactionId: number
  includeExperiment: boolean
}

export const fetchTestData = ({
  interactionId,
  includeExperiment,
}: FetchTestDataParams) =>
  FlowAPI.get<FlowTestingSlugResponse>(
    `/interactions/testing/fetch_or_create_slug?${qs.stringify({
      interactionId,
      includeExperiment,
    })}`
  )

interface SetUrlParams {
  interactionId: number
  isExperiment: boolean
  url: string
}

export const setUrl = ({ interactionId, isExperiment, url }: SetUrlParams) =>
  FlowAPI.post<void>(`/interactions/testing/update_testing_url`, {
    interactionId,
    isExperiment,
    url,
  })
